import React, { useState } from "react";
import {
  Box,
  Typography,
  Modal,
  Select,
  FormControl,
  MenuItem,
  Button,
  TextField,
  InputLabel,
} from "@mui/material";
import closeLogoBlack from "../../../assets/images/chats/closeLogoBlack.svg";
import { useTranslation } from "react-i18next";
import { CloseButton, CloseIcon } from "../../Profille/CustomDrawer";
import { useDispatch } from "react-redux";
import { handleTaskStart } from "../../../appStore/actions/ArkchatGroup/action";
import moment from "moment";

const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

const StartTask = ({
  open,
  taskData,
  setStartTaskOpen,
  isActualTime = false,
  setActualTimeValue,
  actualTimeValue,
  handleActualTime,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });

  const [timeType, setTimeType] = useState(
    taskData?.estimated_time?.timeType || "hours"
  );

  const [timeValue, setTimeValue] = useState("");

  const dispatch = useDispatch();

  // Prevent closing modal on clicks inside the Box
  const handleBoxClick = (event) => {
    event.stopPropagation();
  };
  const handleClose = () => {
    setStartTaskOpen(null);
    setTimeType("");
    setTimeValue("");

    isActualTime && setActualTimeValue("");
  };

const handleClickStart = () => {
  let days = 0;
  let hours = 0;

  if (timeType === "days") {
    days = Number(timeValue);
    hours = days * 24;
  } else {
    hours = Number(timeValue);
    days = hours / 24;
  }

  const reqBody = {
    estimated_time: {
      timeType,
      timeValue: Number(timeValue),

      // 🔥 Send both
      days,
      hours,
    },
    start_time: moment().unix(),
    task_status: 6,
  };

  dispatch(handleTaskStart(taskData?.temp_timetoken, reqBody));
};


  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style} onClick={handleBoxClick}>
          <Box display={"flex"} alignItems={"center"} gap={"0.4rem"}>
            <Box>
              <CloseButton
                onClick={handleClose}
                size="small"
                variant="contained"
              >
                <CloseIcon src={closeLogoBlack} alt="close" />
              </CloseButton>
            </Box>
            <Box>
              <Typography fontSize={"1rem"} variant="h6" fontWeight={600}>
                {!isActualTime ? appContent?.KEY175 : appContent?.KEY313}
              </Typography>
            </Box>
          </Box>
          {!isActualTime ? (
            <Box width={"80%"} m={"auto"}>
              <Typography fontSize={"0.75rem"} variant="caption">
                {appContent?.KEY176}
              </Typography>    
              <br/>
              
            </Box>
          ) : (
            <Box width={"80%"} m={"auto"}>
              <Typography fontSize={"0.75rem"} variant="caption">
                {appContent?.KEY314}
              </Typography>
            </Box>
          )}
          <Box width={"90%"} mx={"auto"} mt={"1.5rem"} textAlign={"center"}>
            <>
              <Button
                onClick={() => setTimeType("hours")}
                variant="outlined"
                sx={{
                  fontSize: "0.85rem",
                  borderRadius: "3px",
                  // borderTopRightRadius: "0px",
                  // borderBottomRightRadius: "0px",
                  textTransform: "none",
                  backgroundColor: timeType === "hours" ? "#183243" : "#D9D9D9",
                  color: timeType === "hours" ? "#fff" : "#183243",
                  borderColor: "#183243",
                  ":hover": {
                    backgroundColor: timeType === "hours" ? "#183243" : "#D9D9D9",
                    color: timeType === "hours" ? "#fff" : "#183243",
                    borderRadius: "3px",
                    borderColor: "#183243",
                  },
                }}
                disabled={isActualTime&&timeType !== "hours"}
              >
                Hours
              </Button>
              <Button
                onClick={() => setTimeType("days")}
                variant="outlined"
                sx={{
                  fontSize: "0.85rem",
                  borderRadius: "3px",
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                  textTransform: "none",
                  backgroundColor: timeType === "days" ? "#183243" : "#D9D9D9",
                  color: timeType === "days" ? "#fff" : "#183243",
                  borderColor: "#183243",
                  ":hover": {
                    backgroundColor:
                      timeType === "days" ? "#183243" : "#D9D9D9",
                    color: timeType === "days" ? "#fff" : "#183243",
                    borderRadius: "3px",
                    borderColor: "#183243",
                  },
                }}
                disabled={isActualTime&&timeType !== "days"}
              >
                Days
              </Button>
            </>

            <FormControl sx={{ width: "100%", mt: "1.5rem" }}>
              <TextField
                sx={{ width: "100%" }}
                type="text"
                variant="standard"
                placeholder={
                  timeType === "hours"
                    ? !isActualTime ? appContent?.KEY311 : appContent?.KEY315
                    : !isActualTime ? appContent?.KEY312 : appContent?.KEY316
                }
                name="timeValue"
                value={!isActualTime ? timeValue : actualTimeValue}
                onChange={(e) => {
                  const regex = /^[0-9\b]+$/;
                  if (e.target.value === "" || regex.test(e.target.value)) {
                    !isActualTime
                      ? setTimeValue(e.target.value)
                      : setActualTimeValue(e.target.value);
                  }
                }}
                inputProps={{ style: {textAlign: 'center'} }}
                required
              />
            </FormControl>
          </Box>
          <Box mt={"1rem"} textAlign={"center"}>
            <Button
              sx={{
                color: "white",
                padding: "0.2rem 1rem",
                borderRadius: "0.2rem",
                bgcolor: "#DB0011",
                boxShadow: "none",
                textTransform: "none",
                ":hover": {
                  color: "white",
                  padding: "0.2rem 1rem",
                  borderRadius: "0.2rem",
                  bgcolor: "#DB0011",
                },
              }}
              disabled={
                !isActualTime ? !timeValue || !timeType : !actualTimeValue
              }
              variant="contained"
              onClick={!isActualTime ? handleClickStart : handleActualTime}
            >
              {!isActualTime ? "Start Task" : "Mark as Completed"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default StartTask;
